import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import './FloatingLoginButton.css';

const FloatingLoginButton = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setIsAuthenticated(!!user);
      
      // Check if user is admin
      if (user) {
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setIsAdmin(userData.role === 'admin' || userData.role === 'administrator');
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error('Error checking user role:', error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Don't show floating button if already on employee or admin pages
  if (location.pathname === '/employee' || location.pathname === '/admin-visual') {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Link to="/employee" className="floating-login-btn">
        <span className="floating-btn-icon">🔐</span>
        <span className="floating-btn-text">Employee Login</span>
      </Link>
    );
  }

  // Show logout button when authenticated
  return (
    <div className="floating-auth-container">
      {isAdmin && (
        <Link to="/admin-visual" className="floating-admin-btn">
          <span className="floating-btn-icon">✏️</span>
          <span className="floating-btn-text">Edit Site</span>
        </Link>
      )}
      <button
        onClick={handleLogout}
        className="floating-logout-btn"
      >
        <span className="floating-btn-icon">🚪</span>
        <span className="floating-btn-text">Logout</span>
      </button>
    </div>
  );
};

export default FloatingLoginButton;

